import React, { useEffect, useState } from "react";
import { Input, InputLabel } from "@mui/material";
import "./CreateUser.css";
import { State, City } from "country-state-city";
import {
  createNewCommunity
} from "../../Services/Community/CommunityAPI/communityApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CommunityOwner, SuperAdmin } from "../../Utils/Constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CircularProgress } from "@mui/material"; // For MUI Loader

function CreatecommunityComp() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // dispatch(fetchCommunityDocName());.
  }, [dispatch]);

  // State for form inputs
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    state: "",
    location: "",
    phone_number: "",
    position: "",
  });

  const userId = localStorage.getItem("user_id");
  const user_type = localStorage.getItem("user_type");




  const handleStateChange = (e) => {
    const selectedStateName = e.target.value;
    const selectedState = states.find(
      (state) => state.name === selectedStateName
    );

    setFormData((prevData) => ({
      ...prevData,
      state: selectedStateName, // Store state name for submission
      city: "",
    }));

    if (selectedState) {
      const stateCities = City.getCitiesOfState("US", selectedState.isoCode);
      setCities(stateCities);
    }

    // Clear validation error for state
    setErrors((prevErrors) => ({
      ...prevErrors,
      state: "",
      city: "", // Reset city error since state is changing
    }));
  };


 const handleInputChange = (e) => {
  const { name, value } = e.target;
  let sanitizedValue = value;

  if (name === "email") {
    // Allow letters, numbers, '@', '.', '_', '-', and ' ' (space)
    sanitizedValue = value.replace(/[^A-Za-z0-9@.\-_ ]/g, "");
  } else if (name === "phone_number") {
    // Allow only numbers & limit to 10 digits
    sanitizedValue = value.replace(/\D/g, "").slice(0, 10);
  } else if (name === "location") {
    // Allow letters, numbers, commas, spaces, and hyphens
    sanitizedValue = value.replace(/[^A-Za-z0-9, -]/g, "");
  } else if (name === "position") {
    // Allow letters, numbers, periods, and spaces
    sanitizedValue = value.replace(/[^A-Za-z0-9. ]/g, "");
    sanitizedValue = sanitizedValue.charAt(0).toUpperCase() + sanitizedValue.slice(1);
  } else if (name === "chat_token") {
    // Allow only numbers & limit to 10 digits
    sanitizedValue = value.replace(/\D/g, "").slice(0, 10);
  } else {
    // Default: Allow only alphabets, spaces, hyphens, and underscores (no special characters)
    sanitizedValue = value.replace(/[^A-Za-z\-_ ]/g, "");

    // Capitalize first letter & keep remaining lowercase
    // sanitizedValue =
    //   sanitizedValue.charAt(0).toUpperCase() + sanitizedValue.slice(1).toLowerCase();
      sanitizedValue = sanitizedValue
  .toLowerCase()
  .split('-')
  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
  .join('-');

  }



  setFormData((prevData) => ({
    ...prevData,
    [name]: sanitizedValue,
  }));

  // ✅ Clear validation error for the current input
  setErrors((prevErrors) => ({
    ...prevErrors,
    [name]: "",
  }));
};


  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));

  //   // Clear validation error for the current input
  //   setErrors((prevErrors) => ({
  //     ...prevErrors,
  //     [name]: "",
  //   }));
  // };

  const validateForm = () => {
    const errors = {};
    const nameRegex = /^[A-Za-z0-9\s\-_\/|]+$/; // Allows letters, numbers, spaces, -, _, /, and |



    if (!formData.first_name) {
      errors.first_name = "First Name is required";
    } else if (!nameRegex.test(formData.first_name)) {
      errors.first_name = "First Name should only contain letters numbers and - _ / |";
    }
    
    if (!formData.last_name) {
      errors.last_name = "Last Name is required";
    } else if (!nameRegex.test(formData.last_name)) {
      errors.last_name = "Last Name should only contain letters";
    }
    if (!formData.state) {
      errors.state = "State is required";
    }
    
    if (!formData.email) {
      errors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(formData.email)) {
      errors.email = "Invalid email format";
    }
    
    if (!formData.position) {
      errors.position = "Position is required";
    }
    if (!formData.phone_number || !/^\d{10}$/.test(formData.phone_number)) {
      errors.phone_number = "Phone Number must be exactly 10 digits";
    }
    
    

    setErrors(errors);

    return Object.keys(errors).length === 0;
  };


  const handleCancel = () => {
    navigate(-1); // Go back to the previous page
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    const formDataToSubmit = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      phone_number: formData.phone_number,
      location: formData.location,
      state: formData.state,
      position: formData.position,


    };
    setLoading(true); // Loader start 

    dispatch(createNewCommunity(formDataToSubmit))
      .unwrap()
      .then((res) => {
        toast.success("User created successfully!");
  
        setTimeout(() => {
          navigate("/dashboard");
        }, 2000);
      })
      .catch((err) => {
        if (err) {
        // console.error("Error Data:", err.response.data);
        console.error("Error Status:", err );
        
        
          setLoading(false); // remove first loader 
      // Check if the error is of type 1 (Object with email errors)
      if (err?.errors?.email) {
        setTimeout(() => {
          toast.error(err?.errors?.email[0]); // Display the first error message for the email
        }, 100);
      }

      // Check if the error is of type 2 (Stringified error details)
      else if (typeof err?.errors === 'string' && err?.errors.includes('A User with this email already exists')) {
        setTimeout(() => {
          toast.error('This email is already registered!'); // General error message
        }, 100);
      } 
      
    } else {
        toast.error("Network error. Please check your connection.");
    }
      })
      .finally(() => {
        setLoading(false); // after API request complete remove loader 
      });
  };

  
  useEffect(() => {
    const usaStates = State.getStatesOfCountry("US");
    setStates(usaStates);
  }, []);
  
  if (loading)
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "400px" }}>
        <CircularProgress color="primary"  size={60} /> {/* MUI Loader */}
      </div>
    );

  return (
    <>
      <div className="back-btn">
        <button onClick={() => navigate(-1)} className="back-btn-button">
          {/* <img src={chevronleft} alt="chevron-left" className="left-icon" />
           */}
          <ArrowBackIcon className="left-icon" />
          Back
        </button>
      </div>
      <div className="community-section">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-center">
            <div className="community-heading create-new">Create User</div>
          </div>
          <div className="create-community-name-table">
            <div className="create-comm-inner-wrap">
              <form className="create-community-form">
                {/* First Name */}
                <div className="main-community-block">
                  <div className="d-flex align-items-center community-city-blk">
                    <div className="comm-name-blk">
                      <InputLabel htmlFor="community-name">
                        First Name
                      </InputLabel>
                      <Input
                        id="first_name"
                        className="input-box"
                        placeholder="Enter User first name"
                        type="text"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleInputChange}
                      />
                      {errors.first_name && (
                        <div className="error-text">{errors.first_name}</div>
                      )}
                    </div>

                    {/* Last Name */}

                    <div className="comm-name-blk">
                      <InputLabel htmlFor="community-name">
                        Last Name
                      </InputLabel>
                      <Input
                        id="last_name"
                        className="input-box"
                        placeholder="Enter User last name"
                        type="text"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleInputChange}
                      />
                      {errors.last_name && (
                        <div className="error-text">{errors.last_name}</div>
                      )}
                    </div>
                    {/* Position */}
                    <div className="comm-name-blk">
                      {/* <div className="mb-6"> */}
                      <InputLabel htmlFor="gender">Position</InputLabel>
                      {/* <select
                        id="gender"
                        name="gender"
                        className="dropdown-box"
                        value={formData.gender} // Bind value to formData.gender
                        onChange={handleTypeChange} // Update gender on change
                      >
                        <option value="" disabled>
                          Select Position
                        </option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select> */}
                       <Input
                        id="gender"
                        className="input-box"
                        placeholder="Enter  Position"
                        type="text"
                        name="position"
                        value={formData.position}
                        onChange={handleInputChange}
                      />

                      {errors.position && (
                        <div className="error-text">{errors.position}</div>
                      )}

                      {/* </div> */}
                    </div>
                  </div>
                  <div className="mb-4 state-type-unit-blk d-flex align-items-center">
                    {/* Email */}
                    <div className="comm-name-blk">
                      <InputLabel htmlFor="community-name">Email</InputLabel>
                      <Input
                        id="email"
                        className="input-box"
                        placeholder="Enter Email"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      {errors.email && (
                        <div className="error-text">{errors.email}</div>
                      )}
                    </div>
                    {/* Phone */}

                    <div className="comm-name-blk">
                      <InputLabel htmlFor="unit">Phone</InputLabel>
                      <Input
                        id="phone_number"
                        className="input-box"
                        placeholder="Enter Phone Number"
                        type="number"
                        name="phone_number"
                        value={formData.phone_number}
                        onChange={handleInputChange}
                      />
                      {errors.phone_number && (
                        <div className="error-text">{errors.phone_number}</div>
                      )}
                    </div>
                  </div>
                  <div className="mb-4 state-type-unit-blk d-flex align-items-center">
                    {/* State */}
                    <div className="city-name-blk">
                      <InputLabel htmlFor="state">State</InputLabel>
                      <select
                        id="state"
                        name="state"
                        className="dropdown-box"
                        value={formData.state}
                        onChange={handleStateChange}
                      >
                        <option value="" disabled selected>
                          Select state
                        </option>
                        {states.map((state) => (
                          <option key={state.id} value={state.name}>
                            {" "}
                            {state.name}
                          </option>
                        ))}
                      </select>
                      {errors.state && (
                        <div className="error-text">{errors.state}</div>
                      )}
                    </div>

                    {/* City */}
                    <div className="city-name-blk">
                      <div className="mb-6">
                        <InputLabel htmlFor="city">
                          Location 
                        </InputLabel>
                        {/* <select
                          id="city"
                          name="city"
                          className="dropdown-box"
                          value={formData.city}
                          onChange={handleCityChange}
                        >
                          <option value="" disabled>
                            Select location
                          </option>
                          {cities.map((city) => (
                            <option key={city.id} value={city.name}>
                              {city.name}
                            </option>
                          ))}
                        </select> */}
                      <Input
                        id="location"
                        className="input-box"
                        placeholder="Enter Location"
                        type="text"
                        name="location"
                        value={formData.location}
                        onChange={handleInputChange}
                      />
                        {errors.location && (
                          <div className="error-text">{errors.location}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="create-comm-btn">
              <button
                type="submit"
                class="blue-filled-btn"
                onClick={handleSubmit}
              >
                Save
              </button>
              <button
                type="submit"
                class="blue-filled-btn"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default CreatecommunityComp;
